/* === GLOBAL PRODUCT TABS SCRIPT === */
document.addEventListener("DOMContentLoaded", function() {
  const tabGroups = document.querySelectorAll(".product-tabs");
  tabGroups.forEach(tabs => {
    const contents = tabs.nextElementSibling?.querySelectorAll("li");
    if (!contents) return;
    const tabItems = tabs.querySelectorAll("li");
    tabItems.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabItems.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));
        tab.classList.add("active");
        contents[index].classList.add("active");
      });
    });
  });
});
